import React from 'react';
import PropTypes from 'prop-types';

export default function Labels({ labels = [], minAnswerWidth }) {
  const { length } = labels;

  return (
    <div className="bipolar-slider-labels">
      {labels.map((label, index) => {
        let textAlign = 'bipolar-slider-label--center';
        if (index === 0 && length > 1) {
          textAlign = 'bipolar-slider-label--left';
        }
        if (index === length - 1 && length > 1) {
          textAlign = 'bipolar-slider-label--right';
        }
        return (
          <span
            className={`bipolar-slider-label ${textAlign}`}
            style={{
              minWidth: `${minAnswerWidth}px`,
              maxWidth: `${100 / labels.length}%`,
            }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: label || '&nbsp;' }}
          ></span>
        );
      })}
    </div>
  );
}

Labels.propTypes = {
  labels: PropTypes.array,
  minAnswerWidth: PropTypes.number,
};
